import { render, staticRenderFns } from "./TownsStreetsMonthServiceElderSelfExpense.vue?vue&type=template&id=f270762c&scoped=true&"
import script from "./TownsStreetsMonthServiceElderSelfExpense.vue?vue&type=script&lang=js&"
export * from "./TownsStreetsMonthServiceElderSelfExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f270762c",
  null
  
)

export default component.exports